import { get } from "@/api/common/request";

// 获取当前登录用户权限
// 入参：userId = user_info.userid
export const fetchUserPrivilege = (userId) => get("/sys/privilege", { user_id: userId });

